/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './hosp-patient-cat-misc-charges.reducer';

export const HospPatientCatMiscCharges = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const hospPatientCatMiscChargesList = useAppSelector(state => state.hospPatientCatMiscCharges.entities);
  const loading = useAppSelector(state => state.hospPatientCatMiscCharges.loading);
  const totalItems = useAppSelector(state => state.hospPatientCatMiscCharges.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="hosp-patient-cat-misc-charges-heading" data-cy="HospPatientCatMiscChargesHeading">
        <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.home.title">Hosp Patient Cat Misc Charges</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/hosp-patient-cat-misc-charges/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.home.createLabel">
              Create new Hosp Patient Cat Misc Charges
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.hospPatientCatMiscCharges.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {hospPatientCatMiscChargesList && hospPatientCatMiscChargesList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('multiplier')}>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.multiplier">Multiplier</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('multiplier')} />
                </th>
                <th className="hand" onClick={sort('multiplierFlag')}>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.multiplierFlag">Multiplier Flag</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('multiplierFlag')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('chargeAmount')}>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.chargeAmount">Charge Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('chargeAmount')} />
                </th>
                <th className="hand" onClick={sort('taxPercent')}>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.taxPercent">Tax Percent</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('taxPercent')} />
                </th>
                <th className="hand" onClick={sort('startDate')}>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.startDate">Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('startDate')} />
                </th>
                <th className="hand" onClick={sort('endDate')}>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.endDate">End Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('endDate')} />
                </th>
                <th className="hand" onClick={sort('suspended')}>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.suspended">Suspended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspended')} />
                </th>
                <th className="hand" onClick={sort('draft')}>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.draft">Draft</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('draft')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.patientCategory">Patient Category</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.charge">Charge</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.hospital">Hospital</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {hospPatientCatMiscChargesList.map((hospPatientCatMiscCharges, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/hosp-patient-cat-misc-charges/${hospPatientCatMiscCharges.id}`} color="link" size="sm">
                      {hospPatientCatMiscCharges.id}
                    </Button>
                  </td>
                  <td>{hospPatientCatMiscCharges.multiplier}</td>
                  <td>{hospPatientCatMiscCharges.multiplierFlag ? 'true' : 'false'}</td>
                  <td>{hospPatientCatMiscCharges.active ? 'true' : 'false'}</td>
                  <td>{hospPatientCatMiscCharges.cursor}</td>
                  <td>{hospPatientCatMiscCharges.lastUpdated}</td>
                  <td>{hospPatientCatMiscCharges.microSec}</td>
                  <td>{hospPatientCatMiscCharges.timestampEntry}</td>
                  <td>{hospPatientCatMiscCharges.chargeAmount}</td>
                  <td>{hospPatientCatMiscCharges.taxPercent}</td>
                  <td>{hospPatientCatMiscCharges.startDate}</td>
                  <td>{hospPatientCatMiscCharges.endDate}</td>
                  <td>{hospPatientCatMiscCharges.suspended ? 'true' : 'false'}</td>
                  <td>{hospPatientCatMiscCharges.draft ? 'true' : 'false'}</td>
                  <td>
                    {hospPatientCatMiscCharges.patientCategory ? (
                      <Link to={`/patient-category/${hospPatientCatMiscCharges.patientCategory.id}`}>
                        {hospPatientCatMiscCharges.patientCategory.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospPatientCatMiscCharges.charge ? (
                      <Link to={`/misc-charges/${hospPatientCatMiscCharges.charge.id}`}>{hospPatientCatMiscCharges.charge.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospPatientCatMiscCharges.hospital ? (
                      <Link to={`/hospital/${hospPatientCatMiscCharges.hospital.id}`}>{hospPatientCatMiscCharges.hospital.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/hosp-patient-cat-misc-charges/${hospPatientCatMiscCharges.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/hosp-patient-cat-misc-charges/${hospPatientCatMiscCharges.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/hosp-patient-cat-misc-charges/${hospPatientCatMiscCharges.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.home.notFound">
                No Hosp Patient Cat Misc Charges found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={hospPatientCatMiscChargesList && hospPatientCatMiscChargesList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default HospPatientCatMiscCharges;
